// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__2gSCc","title":"ClientReferral_title__r2yRq","itemText":"ClientReferral_itemText__3cB1A"};